import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-billing-home',
  standalone: true,
  templateUrl: './rt-icon-billing-home.component.html',
  styleUrls: ['./rt-icon-billing-home.component.scss']
})
export class RtIconBillingHomeComponent {
  @Input() width: number | string = 17;
  @Input() height: number | string = 12;
}
